// components/shell.jsx
import { createContext, useContext, useEffect, useMemo, useState } from 'react'

const ShellCtx = createContext(null)

export function ShellProvider({ children }) {
  const [head, setHead] = useState(null)
  const [overlay, setOverlay] = useState(null)
  const value = useMemo(
    () => ({ head, setHead, overlay, setOverlay }),
    [head, overlay],
  )
  return <ShellCtx.Provider value={value}>{children}</ShellCtx.Provider>
}

function useShell() {
  const ctx = useContext(ShellCtx)
  if (!ctx) throw new Error('ShellProvider Error.')
  return ctx
}

export function HeadSlot({ children }) {
  const { setHead } = useShell()
  useEffect(() => {
    setHead(children)
    return () => setHead(null)
  }, [children, setHead])
  return null
}

export function OverlaySlot({ children }) {
  const { setOverlay } = useShell()
  useEffect(() => {
    setOverlay(children)
    return () => setOverlay(null)
  }, [children, setOverlay])
  return null
}

export function ShellAreas({ isLoginPage, sidebar, children }) {
  const { head, overlay } = useShell()
  return (
    <div id="wrapper">
      {head}
      {overlay}
      {!isLoginPage && sidebar}
      <main id="container">{children}</main>
    </div>
  )
}
